import React from 'react';
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import InputMask from './InputMask';

const numberMask = createNumberMask({
  prefix: '',
  suffix: '',
  includeThousandsSeparator: false,
})

export default props => <InputMask {...props} mask_={numberMask} />;
